import React from 'react';
import PropTypes from "prop-types";
import {pick} from "lodash";
import {Col, Form, FormFeedback, FormGroup, Input, Label} from "reactstrap";
import AppFormDefault from "componentsReusable/AppForm/AppFormDefault";
import {withTranslation} from "react-i18next";

class BsxPrinterAuthForm extends AppFormDefault {
  constructor(props) {
    super(props);

    this.state = {
      data: pick(props.data, [
        'id',
        'name',
      ]),
    };
  }

  render() {
    const {data} = this.state;
    const {errors} = this.props;

    return (
      <Form onSubmit={this.handlerOnSubmit}>
        <FormGroup row>
          <Label md={4}>Nazwa (lokalizacja)</Label>
          <Col md="8">
            <Input
              invalid={!!errors.name}
              placeholder={"Nazwa"}
              onChange={e => this.onChangeData({name: e.target.value})}
              value={data.name}
            />
            <FormFeedback>{errors.name?.join('; ')}</FormFeedback>
          </Col>
        </FormGroup>
      </Form>
    );
  }
}

BsxPrinterAuthForm.defaultProps = {
  data: {
    name: '',
  },
};

BsxPrinterAuthForm.propTypes = {
  errors: PropTypes.object.isRequired,
  data: PropTypes.shape({
    name: PropTypes.string,
  }),
  onSubmit: PropTypes.func.isRequired,
};

export default withTranslation('bsx_printer_auth_form', {withRef:true})(BsxPrinterAuthForm);
